import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/contexts/auth-context";
import { getStatusConfig } from "@shared/status-config";
import { useEscStatusReset } from "@/hooks/use-esc-status-reset";

const OVERLAY_COLOR = "#0ea5e9";

interface StatusData {
  id: number;
  availabilityStatus: string;
}

export function StatusOverlay() {
  const { user, isAuthenticated } = useAuth();
  // Double-ESC anywhere in the app switches a non-working status back.
  useEscStatusReset(user?.id);

  const { data: statuses } = useQuery<StatusData[]>({
    queryKey: ["/api/users/availability-statuses"],
    enabled: !!user,
    refetchInterval: 60000,
  });

  if (!isAuthenticated || !user) return null;

  const myStatus = statuses?.find((s) => s.id === user.id);
  const statusKey = myStatus?.availabilityStatus || "working";

  if (statusKey === "working") return null;

  const config = getStatusConfig(statusKey);

  return (
    <div
      className="fixed inset-0 z-[60] pointer-events-none overflow-hidden"
      style={{
        background: `linear-gradient(to bottom, ${OVERLAY_COLOR}66 0px, ${OVERLAY_COLOR}00 45vh)`,
      }}
    >
      <div
        className="absolute inset-x-0 pt-24 text-center text-white/20 font-bold select-none whitespace-nowrap max-w-[100vw]"
        style={{
          top: "0px",
          fontSize: "8vw",
          lineHeight: "1.1",
          letterSpacing: "0.025em",
        }}
      >
        {config.emoji} {config.label}
      </div>
    </div>
  );
}
